<template>
	<div class="content">
		<div class="row">
			<div class="col-12 titulo-paso">Facturación con I.V.A.: <b>{{ getInfo }}</b></div>
		</div>
		<div class="row">
			<div class="col-12 text-right">
				<b-button id="procesar" variant="success" v-on:click="procesar">PROCESAR</b-button>
				<hr />
			</div>
		</div>
		<div v-if="mostrar" class="row">
			<div class="col-12 text-center">
				<div class="row">&nbsp;</div>
				<div class="row">
					<div class="col-12">
						<h5><i class="fas fa-exclamation fa-fw" /> {{ mensaje }}</h5>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script lang="ts">

	import axios from "axios"


	export default 
	{
		name: "Masivo",
		props: {
			info: String,
		},
		data() {
			return {
				periodo: "",
				mostrar: false,
				mensaje: "",
			}
		},
		created() {

			// Obtenemos el valor del periodo (desde la variable global)
			this.periodo = this.$periodo
		},
		computed: {

			getInfo() {

				return this.info.charAt(0).toUpperCase() + this.info.substr(1)
			}
		},
		methods: {

			procesar() {

				var request = {
					"usuario": this.$usuario,
					"destino": this.$env,
					"tx" : "F0",
					"proceso": "do_fn_iva",
					"nomina": this.info,
					"periodo": this.periodo.substr(0, 7),
				}

				// Activamos la imagen cargando
				window.event.$emit("mostrar-cargando", true)

				axios.post("/face", request, { headers: { "Content-Type": "text/plain", } }).then(response => {

					this.mensaje = "Proceso Finalizado"
					if (response.data.estatus == "NO OK") 
						this.mensaje = response.data.mensaje_error

					this.mostrar = true

					// Ocultamos la imagen cargando
					window.event.$emit("mostrar-cargando", false)

				}).catch(ex => {

					this.mensaje = ex.message
					this.mostrar = true

					// Ocultamos la imagen cargando
					window.event.$emit("mostrar-cargando", false)
				})
			},
		}
	}
</script>
<style scoped>

	.content {
		width: 100%;
		padding: 0px 15px 5px 15px;
	}

</style>
